export default "__VITE_ASSET__DLDBgWM2__"